import { Navigate } from 'react-router';
import { ExpensesListPage } from './list/ExpensesListPage';
import { isReadOnlyAuditor, useExpensesPermissions } from './use-expenses-permissions';

/**
 * «Note spese»'s landing: the expense list, except for the Revisore, who has no «Spese» tab and
 * lands on «Note» (spec §1.8). While the permissions load nothing renders.
 */
export function ExpensesIndex() {
  const permissions = useExpensesPermissions();
  if (permissions.status === 'loading') return null;
  return isReadOnlyAuditor(permissions) ? (
    <Navigate to="/expenses/reports" replace />
  ) : (
    <ExpensesListPage />
  );
}
